"use client";

import { useEffect } from "react";
import PassTicketsLogo from "components/icons/PassTicketsLogo";
import Image from "next/image";
import { useQRCode } from "next-qrcode";
import Link from "next/link";

interface AppDownloadModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  subtitle?: string;
}

const AppDownloadModal = ({
  open,
  onClose,
  title = "FIND THE VIBE.",
  subtitle = "DOWNLOAD THE APP.",
}: AppDownloadModalProps) => {
  const { Canvas } = useQRCode();

  // ✅ LOCK / UNLOCK BODY SCROLL
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    // Cleanup (important)
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center px-4">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-md"
        onClick={onClose}
      />

      {/* Modal */}
      <div
        className="
          relative z-[1000]
          w-full max-w-[420px] sm:max-w-[480px]
          aspect-square
          max-h-[90svh]
          rounded-[16px]
          bg-[#3E3E3EBF]
          p-5 sm:p-6
          flex flex-col
          items-center
          justify-between
          text-center
          shadow-2xl
          animate-scaleIn
        "
      >
        {/* Logo */}
        <PassTicketsLogo height={34} />

        {/* Title */}
        <h2 className="text-white font-bold leading-tight text-[20px] sm:text-[24px]">
          {title}
          <br />
          {subtitle}
        </h2>

        {/* QR */}
        <div className="bg-white rounded-2xl p-3 sm:p-4">
          <Canvas
            text="http://app.pass-tickets.com/"
            options={{ width: 160 }}
          />
        </div>

        {/* Stores */}
        <div className="flex gap-3 sm:gap-4">
          <Link
            target="_blank"
            href="https://apps.apple.com/us/app/pass-tickets/id1596912352"
            className="hover:scale-[1.03] transition-transform"
          >
            <Image
              src="/svg/v2/app_store.png"
              alt="App Store"
              width={140}
              height={46}
              priority
            />
          </Link>

          <Link
            target="_blank"
            href="https://play.google.com/store/apps/details?id=com.starthub.passtickets"
            className="hover:scale-[1.03] transition-transform"
          >
            <Image
              src="/svg/v2/google_play.png"
              alt="Google Play"
              width={140}
              height={46}
              priority
            />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AppDownloadModal;
